import type { KeyboardEvent } from 'react';
import scrollIntoViewIfNeeded from 'scroll-into-view-if-needed';
import { DEFAULT_SCROLL_OPTIONS } from '@atlassian/jira-issue-create-common-types/src/common/constants/index.tsx';
import { getFieldContainerId } from '@atlassian/jira-issue-create-commons/src/common/utils';
import { ESC_KEY_KEYCODE } from '../constants';

export { transformQueryResults } from './fetch-config-query';
export { useWindowSize } from './use-window-size';
export { openInNewTabLinkClickEventHandler } from './link-handler';

export const scrollToElement = (elementId: string) => {
	const fieldRef = document.getElementById(elementId);
	if (fieldRef) {
		scrollIntoViewIfNeeded(fieldRef, DEFAULT_SCROLL_OPTIONS);
	}
};

export const preventEscKeyPropagationKeyPressHandler = (
	event: KeyboardEvent | KeyboardEvent<EventTarget>,
) => {
	if (event?.keyCode === ESC_KEY_KEYCODE) {
		event?.nativeEvent?.stopImmediatePropagation();
	}
};

export const scrollToField = (fieldId: string): void => {
	const fieldWithErrorRef = document.getElementById(getFieldContainerId(fieldId));
	if (fieldWithErrorRef) {
		scrollIntoViewIfNeeded(fieldWithErrorRef, DEFAULT_SCROLL_OPTIONS);
	}
};
